import { Pipe, PipeTransform, inject } from '@angular/core';
import { VendorService } from 'src/app/core/services/vendor.service';

@Pipe({ name: 'searchFilter' })
export class SearchFilterPipe implements PipeTransform {
  private vendorService = inject(VendorService);

  transform(jobCards: any, searchText?: any): any {
    if (!searchText) {
      return jobCards;
    }
    const filteredItems = jobCards.filter((jobcard: any) => {
      //hard coding each parameter
      // return (jobcard.country.toLocaleLowerCase().includes(searchText.toLocaleLowerCase())) || (jobcard.location.toLocaleLowerCase().includes(searchText.toLocaleLowerCase()) || (jobcard.transactionID.toLocaleLowerCase().includes(searchText..toLocaleLowerCase())) );

      //dynamic
      return Object.keys(jobcard).some((key) => {
        return String(jobcard[key]).toLocaleLowerCase().includes(searchText.toLocaleLowerCase());
      });
    });
    this.vendorService.changeCount(filteredItems.length);
    return filteredItems;
  }
}
